$(document).ready(function() {

  // Bare selects
  $('select').on('change', function() {
    $(this).addClass('optionChosen');
    $(this).next().addClass('siblingChanged');
  });

  $('.form-label-group .bttn-light-select:not(.no-label-float)').on('focus', function() {
    $(this).siblings('label').addClass('siblingChanged');
    $(this).addClass('optionChosen');
  });

  // Date pickers
  $('.date input.form-control').on('focus change', function() {
    $(this).siblings('label').addClass('siblingChanged');
  });

  $('.datepicker td, .datepicker th').on('click', function() {
    $('.date input.form-control').focus();
  });

  $('.date input.form-control').blur(function() {
    var _this = $(this);
    if (!$('.datepicker').is(':visible')) {
      setTimeout(function() {
        if (_this.val() == '') {
          _this.siblings('label').removeClass('siblingChanged');
        }
      }, 100);
    }

  });

  });
